/**
 * Mobile Menu on Desktop Enhancement
 *
 * This script redirects the hamburger menu drawer toggle to always
 * open the mobile-menu drawer, regardless of screen size.
 * It also fixes z-index issues between multiple drawers.
 */
document.addEventListener("DOMContentLoaded", function () {
  // Find the hamburger button in the header
  const hamburgerButton = document.querySelector(".header__mobile__hamburger");

  if (hamburgerButton) {
    // Get the ID of the mobile menu
    const mobileMenuDrawer = document.querySelector("mobile-menu");
    const mobileDrawer = mobileMenuDrawer
      ? mobileMenuDrawer.querySelector("[data-drawer]")
      : null;

    if (mobileDrawer) {
      const mobileDrawerId = mobileDrawer.getAttribute("data-drawer");

      // Override the drawer toggle attribute to point to the mobile menu drawer
      hamburgerButton.setAttribute("data-drawer-toggle", mobileDrawerId);
      hamburgerButton.setAttribute("aria-controls", mobileDrawer.id);
    }
  }

  // Fix z-index for the phone model drawer to make it appear above the mobile menu
  const styleElement = document.createElement("style");
  styleElement.textContent = `
    /* Fix z-index for phone model drawer */
    .drawer--phone-model {
      z-index: 5800 !important; /* Higher than mobile menu drawer */
    }
    
    /* Ensure phone model drawer underlay is also above mobile menu */
    .drawer--phone-model .drawer__underlay {
      z-index: 5799 !important;
    }
    
    /* Keep mobile menu at its default z-index */
    .drawer--header {
      z-index: 5600;
    }
  `;
  document.head.appendChild(styleElement);
});
